<template lang="jade">
  {{ dataset }}
</template>

<script>
export default {
  data: () => ({}),
  props: {
    dataset: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// html.vue?672e588e